/**
 * Created by Sandon on 2019-07-03.
 */
export default {
  unitPriceDigits: undefined,
  totalPriceDigits: undefined,
  numberDigits: undefined,
  isFetching: true
}
